export enum RolePermission {
  // Folder permissions
  FOLDER_VIEW = 'FOLDER.VIEW',
  FOLDER_EDIT = 'FOLDER.EDIT',

  // Knowledge permissions
  KNOWLEDGE_VIEW = 'KNOWLEDGE.VIEW',
  KNOWLEDGE_EDIT = 'KNOWLEDGE.EDIT',

  // Task permissions
  TASK_VIEW = 'TASK.VIEW',
  TASK_EDIT = 'TASK.EDIT',

  CLASSROOM_EDIT = 'CLASSROOM.EDIT',
  // CLASSROOM_VIEW = 'CLASSROOM.VIEW',

  // Workspace permissions
  WORKSPACE_ROLE = 'WORKSPACE.ROLE',
  WORKSPACE_USER = 'WORKSPACE.USER',
  WORKSPACE_VIEW = 'WORKSPACE.VIEW',
}

// Helper function để kiểm tra permission
export function hasPermission(userRole: any, permission: RolePermission): boolean {
  if (!userRole)
    return false

  // Nếu là owner, cho phép tất cả
  if (userRole.is_owner === true)
    return true

  // Kiểm tra quyền dựa trên function_id array
  if (userRole.function_id && Array.isArray(userRole.function_id))
    return userRole.function_id.some((func: any) => func.code === permission)

  return false
}

// Helper function để kiểm tra permission cho folder cụ thể
export function hasFolderPermission(userRole: any, permission: RolePermission, folderId: number): boolean {
  if (!userRole)
    return false

  // Nếu là owner, cho phép tất cả
  if (userRole.is_owner === true)
    return true

  // Kiểm tra quyền dựa trên function_id array và workspace_folder_id
  if (userRole.function_id && Array.isArray(userRole.function_id)) {
    const functionItem = userRole.function_id.find((func: any) => func.code === permission)

    if (functionItem) {
      // Nếu workspace_folder_id rỗng, cho phép tất cả folders
      if (!functionItem.workspace_folder_id || functionItem.workspace_folder_id.length === 0)
        return true

      // workspace_folder_id là array of objects với structure: [{ id: number, name: string }]
      // Kiểm tra folderId có trong danh sách được phép không
      return functionItem.workspace_folder_id.some((folderObj: any) => folderObj.id === folderId)
    }
  }

  return false
}

// Helper function để kiểm tra userRole.code có phải là một trong các role nhất định không
export function isUserRole(userRole: any, ...roles: string[]): boolean {
  if (!userRole || !userRole.code)
    return false
  return roles.includes(userRole.code)
}
